import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    GET_CONFIGURATION_SUCCESS,
    GET_CONFIGURATION_FAILURE,
} from './../actions/constants';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';

export function* getConfigurations(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    if (!baseSiteId) return;

    const url = `/occ/v2/${baseSiteId}/configuration?`;
    const params = convertObjectToQueryParams({
            ...action.payload,
        });
    let finalUrl = url + `${params}`;

    try {
        const result = yield axios.get(finalUrl).then((response) => response.data);
        // if (checkImpersonationActive() || checkProxyActive()) {
        //     yield put(getImpersonationUserData());
        // }
        yield put({
            type: GET_CONFIGURATION_SUCCESS,
            payload: {
                ...result,
                optionChosen: action.option,
                orderType: action.orderType,
            },
        });
    } catch (e) {
        yield put({
            type: GET_CONFIGURATION_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

